import { render } from "./PasswordInput.vue?vue&type=template&id=37406bb8&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=js"
export * from "./PasswordInput.vue?vue&type=script&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=37406bb8&scoped=true&lang=css"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37406bb8"]])

export default __exports__